export default __webpack_public_path__ + "static/media/14.694d8e61.svg";